import { View, Text } from 'react-native';

export default function SectionCard({ title, subtitle, children }) {
  return (
    <View className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
      <View className="mb-3">
        <Text className="text-lg font-bold text-slate-950">{title}</Text>
        {subtitle ? <Text className="mt-1 text-sm text-slate-500">{subtitle}</Text> : null}
      </View>
      {children}
    </View>
  );
}
